import yup from '../yup';

export const updateSiteSchema = yup.object().shape({
  title: yup.string()
    .nullable()
    .required('Please enter a site name.')
    .label('Site name'),
});
